<template>
  <div class="app-main-content" type="primary">
    <div
      v-show="showMainList"
      class="grid-view"
    >
      <div class="main-content">
        <search-item
          config-module="700"
          :reset="true"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              type="success"
              @click="toLook"
            >查看</el-button>
            <el-button
              type="primary"
              @click="toAdd"
            >新增</el-button>
            <el-button
              type="primary"
              @click="orderImportVisible=true"
            >批量导入</el-button>
            <el-button
              type="primary"
              @click="toEdit"
            >编辑</el-button>
            <el-button
              type="danger"
              @click="handleCancelOrder"
            >取消</el-button>
            <el-button
              type="danger"
              :disabled="!$checkPermission(['button_OrderManage_delete'])"
              @click="handleDelOrder"
            >删除</el-button>
            <el-button
              type="danger"
              :disabled="!$checkPermission(['button_OrderManage_delete'])"
              @click="handleBatchDelOrder"
            >{{ $t('CargoMsg.Cargo_BatchDelete') }}</el-button>
            <el-button
              type="primary"
              @click="handleFinishOrder"
            >已完成</el-button>
            <el-button
              type="primary"
              :disabled="!$checkPermission(['button_OrderManage_renew'])"
              @click="handleRenewOrder"
            >恢复</el-button>
            <el-button
              type="primary"
              @click="packageImportVisible=true"
            >导入包装</el-button>
            <el-button
              type="primary"
              @click="handleShowReportTemplateSelect"
            >导出Excel</el-button>
            <el-button
              type="primary"
              @click="containerImportVisible=true"
            >导入箱型</el-button>
            <el-button no="print" type="success" @click="toPrint">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="700001"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="700001"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <order-detail
      v-if="showDetail"
      ref="orderDetail"
      @backList="toBackPreView"
    />
    <import-dialog
      title="批量导入订单"
      :action="URL.order.importPoInfo"
      :visible="orderImportVisible"
      folder-name="booking"
      file-name="订单导入模板.xlsx"
      @onClose="importDialogCallback('orderImportVisible')"
    />
    <import-dialog
      title="批量导入包装"
      :action="URL.order.importPoPackage"
      :visible="packageImportVisible"
      folder-name="booking"
      file-name="包装导入模板.xlsx"
      @onClose="importDialogCallback('packageImportVisible')"
    />
    <template-select-dialog
      :visible="templateSelectVisible"
      :filter-json="filterJson"
      :options="templateObj"
      @onSubmit="handleExportExcel"
      @onClose="templateSelectVisible=false"
    />
    <import-dialog
      title="批量导入箱型"
      :action="URL.order.importPoContainer"
      :visible="containerImportVisible"
      folder-name="booking"
      file-name="箱型导入模板.xlsx"
      @onClose="importDialogCallback('containerImportVisible')"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="cancelOrderDialog.visible"
      :title="cancelOrderDialog.title"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span style="color: red;">{{ this.$t('CargoMsg.Cargo_CancelOrderTip7', [this.cancelOrderDialog.keys.length]) }}</span>
      <cargo-ag-grid
        :grid-params.sync="cancelOrderDialog.gridParams"
        :grid-options="cancelOrderDialog.gridOptions"
        :column-defs="cancelOrderDialog.columnDefs"
        :row-data="cancelOrderDialog.rowData"
        :auto-fit-content="false"
        style="width: 100%;min-height: 150px;margin-top: 20px;"
      />
      <span slot="footer">
        <el-button @click="cancelOrder()">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="cancelOrderDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>
<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ImportDialog from './components/Order/importDialog'
import OrderDetail from './components/Order/orderDetail'
import TemplateSelectDialog from '@/components/Cargo/Common/templateSelectDialog'
import {
  queryPoInfoPageable,
  cancelPoInfo,
  deletePoInfo,
  batchFinishPoInfo,
  exportPoInfoDailyReport,
  exportPoInfoPackageDetail,
  exportPoInfoFclReport,
  exportPoReport,
  batchRenewPoInfo, batchDeletePoInfo
} from '@/api/OMS/order'
import URL from '@/api/urlTranslator'
import convertResToBlob from '@/utils/convertResToBlob'
import { getLoading } from '@/utils/utilBaseElement'
import { CANCELED, FINISHED } from '@/class/cargo/model/parameters/OrderStateType'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
export default {
  name: 'Order',
  components: { searchItem, ImportDialog, OrderDetail, TemplateSelectDialog, cargoTemplateSelectorDialog },
  data() {
    return {
      URL,
      isAdvancedQuery: false, // 是否为高级查询
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      showDetail: false,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.toLook
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: '订单号',
          colId: 'poNo',
          field: 'poNo',
          width: 150
        },
        {
          headerName: '客户',
          colId: 'customerName',
          field: 'customerName',
          width: 150
        },
        {
          headerName: '供应商',
          colId: 'supplierName',
          field: 'supplierName',
          width: 150
        },
        {
          headerName: '干线业务编号',
          colId: 'jobNo',
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          colId: 'jobEtd',
          field: 'jobEtd',
          width: 150
        },
        {
          headerName: '起运港',
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(
              TYPE_NAMES.basic_data_Seaport,
              'code',
              params.value,
              'englishName'
            )
          }
        },
        {
          headerName: '目的港',
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(
              TYPE_NAMES.basic_data_Seaport,
              'code',
              params.value,
              'englishName'
            )
          }
        },
        {
          headerName: '状态',
          colId: 'state',
          field: 'state',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(
              TYPE_NAMES.local_cache_OrderStateType$ORDER_STATE_TYPES,
              'code',
              params.value,
              'chineseName'
            )
          }
        },
        {
          headerName: 'PO创建时间',
          colId: 'poCreationDate',
          field: 'poCreationDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '操作要求',
          colId: 'operationRequirement',
          field: 'operationRequirement',
          width: 150
        },
        {
          headerName: '装箱完成日期',
          colId: 'loadingDate',
          field: 'loadingDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '要求进仓时间',
          colId: 'requestedIncomeDate',
          field: 'requestedIncomeDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '预计进仓时间',
          colId: 'estimatedIncomeDate',
          field: 'estimatedIncomeDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '进仓延误原因',
          colId: 'incomeDelayReason',
          field: 'incomeDelayReason',
          width: 150
        },
        {
          headerName: '预计离港时间',
          colId: 'etd',
          field: 'etd',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '离港延误原因',
          colId: 'departureDelayReason',
          field: 'departureDelayReason',
          width: 150
        },
        {
          headerName: '要求送达时间',
          colId: 'requestedDeliveryDate',
          field: 'requestedDeliveryDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '预计送达时间',
          colId: 'estimatedDeliveryDate',
          field: 'estimatedDeliveryDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '收货地址',
          colId: 'deliveryAddress',
          field: 'deliveryAddress',
          width: 150
        },
        {
          headerName: '备注',
          colId: 'remarks',
          field: 'remarks',
          width: 150
        },
        {
          headerName: '创建人',
          colId: 'createUserName',
          field: 'createUserName',
          width: 150
        },
        {
          headerName: '接收时间',
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150
        },
        {
          headerName: '更新人',
          colId: 'modifyUserName',
          field: 'modifyUserName',
          width: 150
        },
        {
          headerName: '更新时间',
          colId: 'dateModified',
          field: 'dateModified',
          width: 150
        },
        {
          headerName: '箱号',
          colId: 'containerno',
          field: 'containerno',
          width: 150
        },
        {
          headerName: '箱型',
          colId: 'eqsize',
          field: 'eqsize',
          width: 150
        },
        {
          headerName: '箱种',
          colId: 'eqtype',
          field: 'eqtype',
          width: 150
        },
        {
          headerName: '封号',
          colId: 'sealno',
          field: 'sealno',
          width: 150
        },
        {
          headerName: '来源',
          colId: 'source',
          field: 'source',
          width: 150
        },
        {
          headerName: '销售',
          colId: 'salerName',
          field: 'salerName',
          width: 150
        },
        {
          headerName: '销售部门',
          colId: 'salerDept',
          field: 'salerDept',
          width: 150
        },
        {
          headerName: '销售公司',
          colId: 'salerOffice',
          field: 'salerOffice',
          width: 150
        },
        {
          headerName: '操作',
          colId: 'operaterName',
          field: 'operaterName',
          width: 150
        },
        {
          headerName: '操作部门',
          colId: 'operaterDept',
          field: 'operaterDept',
          width: 150
        },
        {
          headerName: '操作公司',
          colId: 'operaterOffice',
          field: 'operaterOffice',
          width: 150
        },
        {
          headerName: this.$t('Order.Shipper'),
          field: 'shipper',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 150
        },
        {
          headerName: this.$t('Order.RelatedParty'),
          field: 'relatedParty',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 150
        },
        {
          headerName: this.$t('Order.EntrustingDate'),
          field: 'entrustingDate',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Order.Consignee'),
          field: 'consignee',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 150
        }
      ],
      rowData: [],
      orderImportVisible: false,
      packageImportVisible: false,
      containerImportVisible: false,
      templateSelectVisible: false,
      templateObj: [
        {
          key: '',
          name: '订单-包装明细列表'
        },
        {
          key: 'CBCC',
          name: 'Daily report'
        },
        {
          key: 'FCL',
          name: 'FCL report'
        },
        {
          key: 'PO',
          name: 'PO report'
        }
      ],
      cancelOrderDialog: {
        title: this.$t('CargoMsg.Cargo_CancelOrderTip6'),
        visible: false,
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('SeaExport.OrderNo2'),
            field: 'poNo',
            colId: 'poNo',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Reason'),
            field: 'message',
            colId: 'message',
            width: 300
          }
        ],
        gridOptions: {},
        rowData: [],
        keys: []
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'OMS_ORDER',
        data: {}
      }
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    }
  },
  beforeMount() {
    this.toQuery()
  },
  methods: {
    fetchOrderRequirement() {
      this.fullscreenLoading = getLoading()
      queryPoInfoPageable(this.filter)
        .then((res) => {
          this.filter.total = Number(res.data.total)
          this.rowData = res.data.list
          this.fullscreenLoading.close()
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.poNo = keyword
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryPoInfoPageable(this.filter).then((res) => this.handleQueryData(res))
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      console.log('----toAdvancedQuery----')
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryPoInfoPageable(this.filterJson).then((res) =>
        this.handleQueryData(res)
      )
    },
    importDialogCallback(type) {
      this[type] = false
    },
    // 返回
    toBackPreView(toView) {
      this.showDetail = false
      this.fetchOrderRequirement()
    },
    showDetailDialog(uuid, oprationType, curSelected) {
      this.$nextTick(() => {
        this.$refs.orderDetail.showDetail(uuid, oprationType, curSelected)
      })
    },
    toLook(event) {
      const curSelected = event.data
      const { api } = this.gridOptions
      let selectedRows = api.getSelectedRows()
      if (!selectedRows) selectedRows = []
      let exit = false
      if (selectedRows.length > 0 && curSelected) {
        for (const selectedRow of selectedRows) {
          if (curSelected.uuid === selectedRow.uuid) {
            exit = true
            break
          }
        }
      }
      if (!exit && curSelected) selectedRows.splice(0, 0, curSelected)
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要查看的订单')
        return
      }
      const uuid = selectedRows.map((item) => {
        return {
          uuid: item.uuid,
          poNo: item.poNo,
          state: item.state
        }
      })
      this.showDetail = true
      this.showDetailDialog(uuid, 1, curSelected)
    },
    // 新增
    toAdd() {
      this.showDetail = true
      this.showDetailDialog(undefined, 2)
    },
    // 编辑
    toEdit() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要编辑的订单')
        return
      }
      if (selectedRows.length > 1) {
        this.$message.error('一次只能编辑一条订单')
        return
      }
      if (selectedRows[0].state !== 0) {
        this.$message.error('只有操作中的订单可以编辑')
        return
      }
      this.showDetail = true
      console.log(selectedRows[0])
      this.showDetailDialog(selectedRows, 3)
    },
    handleCancelOrder() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      this.cancelOrderDialog.keys = []
      this.cancelOrderDialog.rowData = []
      for (const item of selectedRows) {
        if (this.cancelOrderDialog.keys.length === 0) {
          this.cancelOrderDialog.keys.push(item.uuid)
        } else {
          if (this.cancelOrderDialog.keys.findIndex(p => p === item.uuid) < 0) {
            this.cancelOrderDialog.keys.push(item.uuid)
          }
        }
        if (item.state !== 0) {
          if (item.state === CANCELED.code) {
            this.cancelOrderDialog.rowData.push({ poNo: item.poNo, message: this.$t('CargoMsg.Cargo_CancelOrderTip8', [CANCELED.chineseName]) })
          }
          if (item.state === FINISHED.code) {
            this.cancelOrderDialog.rowData.push({ poNo: item.poNo, message: this.$t('CargoMsg.Cargo_CancelOrderTip8', [FINISHED.chineseName]) })
          }
        } else if (new Date(item.atd) < new Date() && item.jobNo) {
          this.cancelOrderDialog.rowData.push({ poNo: item.poNo, message: this.$t('CargoMsg.Cargo_CancelOrderTip2') })
        } else if (new Date(item.atd) < new Date()) {
          this.cancelOrderDialog.rowData.push({ poNo: item.poNo, message: this.$t('CargoMsg.Cargo_CancelOrderTip3') })
        } else if (item.jobNo) {
          this.cancelOrderDialog.rowData.push({ poNo: item.poNo, message: this.$t('CargoMsg.Cargo_CancelOrderTip4') })
        }
      }
      if (this.cancelOrderDialog.rowData.length > 0) {
        this.cancelOrderDialog.visible = true
      } else {
        this.$confirm(this.$t('CargoMsg.Cargo_CancelOrderTip5', [this.cancelOrderDialog.keys.length]), this.$t('CargoMsg.Cargo_CancelOrderTip6'), {
          type: 'warning'
        }).then(() => {
          this.cancelOrder()
        })
      }
    },
    handleDelOrder() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error(this.$t('Order.PleaseSelectTheOrderToDelete'))
        return
      }
      if (selectedRows.length > 1) {
        this.$message.error(this.$t('Order.onlyOneOrderCanBeDeletedAtATime'))
        return
      }
      const item = selectedRows[0]
      if (item.state !== -1) {
        this.$message.error(this.$t('Order.onlyCancelledOrdersCanBeDeleted'))
        return
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, this.$t('Order.PoNo')),
          h('span', { style: 'margin: 0 10px' }, item.poNo)
        ]),
        h('p', { style: 'color: red' }, this.$t('Order.areYouSureToDeleteThisOrder'))
      ])
      this.$confirm(content, this.$t('Order.deleteOrder'), {
        type: 'warning'
      }).then(() => {
        deletePoInfo({ poInfoUuid: item.uuid }).then((res) => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.fetchOrderRequirement()
        })
      })
    },
    handleBatchDelOrder() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error(this.$t('Order.PleaseSelectTheOrderToDelete'))
        return
      }
      const poNos = []
      const poInfoKeys = []
      for (const item of selectedRows) {
        if (item.state !== -1) {
          this.$message.error(this.$t('Order.onlyCancelledOrdersCanBeDeleted'))
          return
        }
        poNos.push(item.poNo)
        poInfoKeys.push(item.uuid)
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, this.$t('Order.PoNo') + ':'),
          h('span', { style: 'margin: 0 10px;display:inline-block;width:80%;word-wrap:break-word;white-space:normal;' }, poNos.join(','))
        ]),
        h('p', { style: 'color: red' }, this.$t('Order.areYouSureToDeleteThisOrder'))
      ])
      this.$confirm(content, this.$t('Order.deleteOrder'), {
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        batchDeletePoInfo(poInfoKeys).then((res) => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.fetchOrderRequirement()
        })
      })
    },
    handleFinishOrder() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要完成的订单')
        return
      }
      const notOperating = selectedRows.filter((item) => item.state !== 0)
      console.log('notOperating', notOperating)
      if (notOperating.length !== 0) {
        this.$message.error('只有操作中的订单才能进行此操作')
        return
      }
      const itemNos = selectedRows.map((item) => item.poNo)
      const itemUuids = selectedRows.map((item) => item.uuid)
      const h = this.$createElement
      const content = h('div', null, [
        h('span', null, '订单号:'),
        h('p', { style: 'overflow-wrap: break-word;' }, itemNos.join(',')),
        h('p', { style: 'color: red' }, '是否确定订单已完成?')
      ])
      this.$confirm(content, '订单完成', {
        type: 'warning'
      }).then(() => {
        batchFinishPoInfo({ poInfoUuids: itemUuids.join(',') }).then((res) => {
          this.$message.success('操作成功')
          this.fetchOrderRequirement()
        })
      })
    },
    handleShowReportTemplateSelect() {
      this.templateSelectVisible = true
    },
    handleExportExcel(e) {
      switch (e) {
        case 'CBCC':
          this.handleExportDailyReport()
          break
        case 'FCL':
          this.handleExportFclReport()
          break
        case 'PO':
          this.handleExportPoReport()
          break
        default:
          this.handleExportPoInfoPackageDetail()
      }
    },
    handleExportDailyReport() {
      const params = {
        ...this.filterJson,
        templateName: 'CBCC'
      }
      this.fullscreenLoading = getLoading()
      exportPoInfoDailyReport(params)
        .then((res) => {
          this.fullscreenLoading.close()
          this.templateSelectVisible = false
          convertResToBlob(res)
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    handleExportPoInfoPackageDetail() {
      this.fullscreenLoading = getLoading()
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      let params = {}
      if (selectedRows.length === 0) {
        params = {
          conditions: this.filterJson.conditions,
          branchId: this.$store.getters.currentOfficeId,
          templateName: ''
        }
      } else {
        params = {
          poNos: selectedRows.map(item => item.poNo).join(','),
          templateName: ''
        }
      }
      exportPoInfoPackageDetail(params)
        .then((res) => {
          this.fullscreenLoading.close()
          this.templateSelectVisible = false
          convertResToBlob(res)
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    handleExportFclReport() {
      const params = {
        ...this.filterJson,
        templateName: 'CBCC'
      }
      this.fullscreenLoading = getLoading()
      exportPoInfoFclReport(params)
        .then((res) => {
          this.fullscreenLoading.close()
          this.templateSelectVisible = false
          convertResToBlob(res)
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    handleExportPoReport() {
      const params = {
        ...this.filterJson,
        templateName: 'CBCC'
      }
      this.fullscreenLoading = getLoading()
      exportPoReport(params)
        .then((res) => {
          this.fullscreenLoading.close()
          this.templateSelectVisible = false
          convertResToBlob(res)
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    handleRenewOrder() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要取消的订单')
        return
      }
      const orderNos = []
      const itemUuids = []
      for (const item of selectedRows) {
        if (item.state !== -1) {
          this.$message.error('操作失败，只对已取消的订单进行恢复。')
          return
        }
        orderNos.push(item.poNo)
        itemUuids.push(item.uuid)
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('span', null, '订单号:'),
        h('p', { style: 'overflow-wrap: break-word;' }, orderNos.join(',')),
        h('p', { style: 'color: red' }, '是否确定订单恢复?')
      ])
      this.$confirm(content, '订单恢复', {
        type: 'warning'
      }).then(() => {
        batchRenewPoInfo({ poInfoUuids: itemUuids.join(',') }).then((res) => {
          this.$message.success('操作成功')
          this.fetchOrderRequirement()
        })
      })
    },
    cancelOrder() {
      if (this.cancelOrderDialog.visible) {
        this.cancelOrderDialog.visible = false
      }
      cancelPoInfo(this.cancelOrderDialog.keys).then((res) => {
        this.$message.success(this.$t('CargoMsg.Cargo_CancelOrder', [res.data, this.cancelOrderDialog.keys.length - res.data]))
        this.fetchOrderRequirement()
      })
    },
    toPrint() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseCheckAtLeastOnePieceOfData'))
        return
      }
      this.templateSelectorDialog.data = { 'UUIDS': Array.from(selectedRows, p => `${p.uuid}`) }
      this.templateSelectorDialog.visible = true
    }
  }
}
</script>
